"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Opportunity_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Opportunity = void 0;
const typeorm_1 = require("typeorm");
const data_ui_1 = require("../data-ui");
const layouts_1 = require("../data-ui/layouts");
const events_1 = require("../events");
const account_1 = require("./account");
const contact_profile_enum_1 = require("./contact-profile-enum");
const affiliate_id_1 = require("./affiliate-id");
const cancellation_reason_1 = require("./cancellation-reason");
const documentation_type_1 = require("./documentation-type");
const external_id_type_1 = require("./external-id-type");
const invoicing_target_1 = require("./invoicing-target");
const job_1 = require("./job");
const job_automation_1 = require("./job-automation");
const opportunity_option_1 = require("./opportunity-option");
const opportunity_service_1 = require("./opportunity-service");
const opportunity_tags_1 = require("./opportunity-tags");
const form_opportunity_1 = require("./order-form-questions/form-opportunity");
const partner_briefing_documents_1 = require("./partner-briefing-documents");
const planning_documentation_enum_1 = require("./planning-documentation-enum");
const product_opportunity_1 = require("./product_opportunity");
const rejected_opportunity_1 = require("./rejected-opportunity");
const service_link_1 = require("./service-link");
let Opportunity = Opportunity_1 = class Opportunity {
};
Opportunity.EVENTS = (0, events_1.makeEventsForClass)(Opportunity_1);
Opportunity.SFID_PREFIX = '006';
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.PrimaryColumn)({
        type: 'character varying',
        length: 18,
        name: 'sfid',
        default: () => "gid_generate_sfid('006')",
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "id", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.Override({ generated: true }),
    (0, typeorm_1.Column)('character varying', {
        nullable: true,
        length: 30,
        name: 'api_id__c',
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "apiId", void 0);
__decorate([
    data_ui_1.DataUi.SearchField(),
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('idx_trgm_opportunity_name', { synchronize: false }),
    (0, typeorm_1.Column)('character varying', {
        nullable: false,
        length: 121,
        name: 'name',
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "name", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: documentation_type_1.DocumentationTypeEnum,
        default: documentation_type_1.DocumentationTypeEnum.NONE,
        name: 'dokumentationstyp__c',
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "documentationType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'enum',
        enum: planning_documentation_enum_1.PlanningDocumentationEnum,
        default: planning_documentation_enum_1.PlanningDocumentationEnum.NONE,
        name: 'planning_documentation__c',
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "planningDocumentation", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Column)({
        type: 'enum',
        nullable: false,
        enum: invoicing_target_1.InvoicingTargetEnum,
        name: 'invoicing_target__c',
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "invoicingTarget", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.Column)({
        nullable: true,
        type: 'enum',
        enum: external_id_type_1.ExternalIdTypeEnum,
        name: 'external_id_type__c',
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "externalIdType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
        type: 'integer',
        name: 'default_days_for_delivery__c',
    }),
    __metadata("design:type", Number)
], Opportunity.prototype, "defaultDaysForDelivery", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Expected Brand Hardware Delivery' }),
    (0, typeorm_1.Column)('integer', {
        nullable: true,
    }),
    __metadata("design:type", Number)
], Opportunity.prototype, "brandHardwareDeliveryDays", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('email_types'),
    (0, typeorm_1.Column)({
        name: 'email_type__c',
        nullable: true,
        length: 50,
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "emailType", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'integer',
        name: 'assembly_time_days__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], Opportunity.prototype, "assemblyTimeDays", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'bool',
        name: 'readiness_date_required__c',
        default: false,
    }),
    __metadata("design:type", Boolean)
], Opportunity.prototype, "readinessDateRequired", void 0);
__decorate([
    (0, typeorm_1.Index)('hc_idx_opportunity_test_opportunity__c'),
    (0, typeorm_1.Column)({
        type: 'bool',
        name: 'test_opportunity__c',
        default: false,
    }),
    __metadata("design:type", Boolean)
], Opportunity.prototype, "testOpportunity", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'bool',
        name: 'is_active__c',
        default: true,
    }),
    __metadata("design:type", Boolean)
], Opportunity.prototype, "isActive", void 0);
__decorate([
    (0, typeorm_1.Column)({
        type: 'bool',
        name: 'multiday__c',
        default: false,
    }),
    __metadata("design:type", Boolean)
], Opportunity.prototype, "multiDay", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('StandardValueSet.OpportunityStage'),
    (0, typeorm_1.Index)('hc_idx_opportunity_stagename'),
    (0, typeorm_1.Column)({
        type: 'varchar',
        length: 40,
        name: 'stagename',
    }),
    __metadata("design:type", String)
], Opportunity.prototype, "stageName", void 0);
__decorate([
    (0, typeorm_1.Column)({
        nullable: true,
        type: 'date',
        name: 'closedate',
    }),
    __metadata("design:type", Date)
], Opportunity.prototype, "closeDate", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)({
        name: 'createddate',
    }),
    __metadata("design:type", Date)
], Opportunity.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Index)('hc_idx_opportunity_lastmodifieddate'),
    (0, typeorm_1.UpdateDateColumn)({
        name: 'lastmodifieddate',
    }),
    __metadata("design:type", Date)
], Opportunity.prototype, "updatedAt", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => job_1.Job, (job) => job.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "jobs", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => affiliate_id_1.AffiliateId, (adminProfile) => adminProfile.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "affiliateIds", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => rejected_opportunity_1.RejectedOpportunity, (rejectedOpportunities) => rejectedOpportunities.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "rejectedOpportunities", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)(() => rejected_opportunity_1.RejectedOpportunity, (rejectedOpportunityServices) => rejectedOpportunityServices.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "rejectedOpportunityServices", void 0);
__decorate([
    data_ui_1.DataUi.Override({ allowCloning: false }),
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => form_opportunity_1.FormOpportunity, (formOpportunity) => formOpportunity.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "formOpportunitySet", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => job_automation_1.JobAutomation, (jobAutomation) => jobAutomation.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "jobAutomation", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => cancellation_reason_1.CancellationReasonOpportunity, (cr) => cr.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "cancellationReasonOpportunities", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => opportunity_service_1.OpportunityService, (cr) => cr.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "opportunityServices", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToMany)((type) => service_link_1.ServiceLink, (cr) => cr.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "serviceLinks", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM),
    (0, typeorm_1.OneToOne)(() => opportunity_option_1.OpportunityOption, (oo) => oo.opportunity, {
        eager: true,
    }),
    __metadata("design:type", opportunity_option_1.OpportunityOption)
], Opportunity.prototype, "opportunityOptions", void 0);
__decorate([
    (0, typeorm_1.OneToMany)(() => partner_briefing_documents_1.PartnerBriefingDocument, (p) => p.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "partnerBriefingDocuments", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.SHOW_IN_TABLE),
    (0, typeorm_1.Index)('hc_idx_opportunity_accountid'),
    (0, typeorm_1.ManyToOne)(() => account_1.Account),
    (0, typeorm_1.JoinColumn)({
        name: 'accountid',
    }),
    __metadata("design:type", account_1.Account)
], Opportunity.prototype, "brand", void 0);
__decorate([
    data_ui_1.DataUi.Override({ readOnly: true }),
    (0, typeorm_1.OneToMany)(() => product_opportunity_1.ProductOpportunity, (product_opportunities) => product_opportunities.opportunity),
    __metadata("design:type", Array)
], Opportunity.prototype, "productOpportunities", void 0);
__decorate([
    (0, typeorm_1.ManyToMany)((type) => opportunity_tags_1.OpportunityTags, (opportunityTag) => opportunityTag.opportunities),
    (0, typeorm_1.JoinTable)({
        name: 'opportunity_opportunity_tag',
    }),
    __metadata("design:type", Array)
], Opportunity.prototype, "tags", void 0);
Opportunity = Opportunity_1 = __decorate([
    data_ui_1.DataUi.Permissions({
        read: [
            contact_profile_enum_1.ContactProfileEnum.CUSTOMER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_ONBOARDING,
            contact_profile_enum_1.ContactProfileEnum.BRAND_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.GID,
            contact_profile_enum_1.ContactProfileEnum.PARTNER_MANAGEMENT,
            contact_profile_enum_1.ContactProfileEnum.FINANCE,
            contact_profile_enum_1.ContactProfileEnum.FINANCE_POWER_USER,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT,
            contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER,
        ],
        write: [contact_profile_enum_1.ContactProfileEnum.PRODUCT, contact_profile_enum_1.ContactProfileEnum.PRODUCT_POWER_USER],
    }),
    data_ui_1.DataUi.Name({
        name: 'Opportunity',
        nameProperties: ['name'],
    }),
    data_ui_1.DataUi.DefaultLayoutConfig(layouts_1.HIDE_IN_TABLE),
    (0, typeorm_1.Unique)(['name', 'brand']),
    (0, typeorm_1.Entity)('opportunity', { schema: 'public', synchronize: true })
], Opportunity);
exports.Opportunity = Opportunity;
//# sourceMappingURL=opportunity.js.map